import { createAsyncThunk } from '@reduxjs/toolkit';
import VDKEventLanguagesApi from '@infrastructure/vdk-event-languages-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createVDKEventLanguageAsync = createAsyncThunk('vdkEventLanguages/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.createVDKEventLanguage(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateVDKEventLanguageAsync = createAsyncThunk('vdkEventLanguages/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.updateVDKEventLanguage(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteVDKEventLanguageAsync = createAsyncThunk('vdkEventLanguages/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.deleteVDKEventLanguage(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventLanguageByIdAsync = createAsyncThunk('vdkEventLanguages/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.getVDKEventLanguageById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventLanguagesByEventIdAsync = createAsyncThunk('vdkEventLanguages/getByEventId', async (eventId, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.getVDKEventLanguagesByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
